import 'datatables.net-dt/css/jquery.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import WaitingModal from '../../generics/WaitingModal';
import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import RaisedButton from 'material-ui/RaisedButton';
import { biometricsOption, getDateHour, unitExportId, unitRequest } from '../../../libs/services';

var Config = require('../../../config');
var session = sessionStorage.getItem('health_facilities_name');
var report = require('../../generics/report_head');

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

pdfMake.vfs = pdfFonts.pdfMake.vfs;

class ReportSend extends Component{
	constructor(props){
		super(props);

		this.setTable = this.setTable.bind(this);
		this.getList = this.getList.bind(this);
		this.onPrint = this.onPrint.bind(this);
		this.onCancel = this.onCancel.bind(this);

		this.state = {
			date:"",
			hour:"",
			columns:[
				{title: "No.", visible:true},
				{title: "No. Unidad", visible:true},
				{title: "Componente", visible:true},
				{title: "Donación", visible:true},
				{title: "Vol", visible:true},
				{title: "Grupo", visible:true},
				{title: "Nombre del Donante", visible:true}
			],
			listado:[],
			medical_staff:"",
			filename:"Reporte Envio de Unidades.pdf",
			negative_samples:"",
			folio:"",
			receptor_name:"",
			report_date:"",
			components_count:[],
			observations:"",
		};
	}

	async componentWillMount(){
		this.setState({
			medical: this.props.medical_staff || sessionStorage.getItem('medical_staff')
		});

		var response = await getDateHour();
		if(response !== undefined){
			var aux = response.split('|');
			
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				date:aux[0],
				hour:hours,
				folio:"",
			});
		}
	}
	
	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	async componentDidMount(){

		this.props.socket.onerror = (event)=> {
			console.log(event);
		};

		this.props.socket.onmessage = (event) => {
		    var res = JSON.parse(event.data);
		    if(res.Error !== undefined){
		    	swal('¡Error!', res.Error, 'error');
		    }
		    console.log(res);
		}

		var response = await biometricsOption('BIO_F_BIO');
		if(response !== undefined){
			var col = [];
			response.map((res)=>{
				return res.code !== null ?
					this.setState({
						columns:[...this.state.columns, {title:res.code, type:'bio', id:res.id, visible:true}]
					})
				: this.setState({
					columns:[...this.state.columns, {title:res.name, type:'bio', id:res.id, visible:true}]
				})
			});

			this.setState({
				columns:[...this.state.columns, 
					{title:'F. Ext', visible:true}, 
					{title: 'F. Cad', visible:true},
					{title: 'F. Devolución', visible:true}
				]
			});

			setTimeout(()=>{
				this.getList();
			}, 500);
			
		}
	}

	async getList(){
		var tipo = this.props.match.params.tipo;
		var url = '';
		var id = this.props.match.params.id;
		var response;
		this.props.waiting.handleShow('Cargando...');
		if(tipo === 'envio'){
			response = await unitExportId(id);
			//url = 'unit_export/'+id;
		}else if(tipo === 'despacho'){
			//url = 'unit_request/'+id;
			response = await unitRequest(id);
		}

		if(response !== undefined){
			var units = response.units !== undefined ? response.units : response.units_asociation;
			var list = [];
			var negative = "";
			units.map((u, i)=>{
				var obj = [];
				obj.push(
					(i+1).toString(),
					u.unit.unit_number,
					u.blood_component_name,
					u.donation_type,
					u.unit.volume,
					u.unit.group+
					(u.unit.rh === 'POSITIVO' ? '+': u.unit.rh === 'NEGATIVO' ? '-' : ''),
					u.donor_name
				)

				if(u.biometrics !== null){
					this.state.columns.map((col)=>{
						if(col.type === 'bio'){
							var index = u.biometrics.findIndex(obj => obj.biometrics_id === col.id);
							
							if(index !== -1){
								obj.push(u.biometrics[index].value);
							}else{
								obj.push('');
							}
						}
					});
					
				}else{
					this.state.columns.map((col)=>{
						if(col.type === 'bio'){
							col.visible = false
							obj.push('')
						}

						return 

					});
					this.forceUpdate();
				}
					

				obj.push(
					u.extraction_date || '22',
					moment(u.unit.caducidad).format('DD/MM/YYYY'),
					u.returned_timestamp === null ? "" : moment(u.returned_timestamp).format('DD/MM/YYYY')
				)

				if(negative === ""){
					negative = u.negative_samples;	
				}
				
				return list.push(obj)
			});
			var folio = response.folio  !== null || response.folio !== "" ? response.folio : response.unit_request.folio;
			
			this.setState({
				listado:list, 
				folio: folio || "",
				components_count: response.total_components.length > 0 ? response.total_components : [],
				observations:response.observations,
				medical_staff:response.medical_staff,
				receptor_name: response.receptor_name,
				report_date: moment(response.date).format('DD/MM/YYYY')+' '+
						moment(response.hour, 'HH:mm:ss').format('HH:mm')
			});

			setTimeout(()=>{
				this.setTable();	
			}, 500);
			
		}

		this.props.waiting.handleClose();
	}

	setTable(){
		this.$el = $(this.el);

		this.$el.DataTable({
			data: this.state.listado,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"fnInfoCallback":null,
			},
			paging:false,
			responsive:true,
			searching: false,
			autoWidth: false,
			info:false
		});
	}

	async onPrint(e){
		e.preventDefault();
   		this.waiting_modal.handleShow('Imprimiendo...');
				
	    var obj ={};
	    obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
	    obj.id = this.props.match.params.id;
	    obj.nEtiqueta = [0];
		obj.file_type = this.props.match.params.tipo == "despacho"?"unit_export_hemored":"unit_export";
		obj.option = this.props.match.params.tipo === 'despacho' ? 'hemored' : 'externo';
	    
		var type = await this.props.getDocumentType(obj.file_type);

		var document;
		if(type.print_type === 'template'){
			document = await this.props.printDocumentTemplate(obj, type.print_automatically);
		}else if(type.print_type === 'external'){
			document = await this.props.printDocumentExternal(obj, type.print_automatically);
		}

		if(document !== undefined){
			this.waiting_modal.handleClose();
			this.setState({ show: false});
		}else{
			this.waiting_modal.handleClose();
		}

	    
	}
	
	directPrint(response, label_type){
		//PRINTER
		var reader = new FileReader();
		reader.readAsDataURL(response); 
		reader.onloadend = function() {
			var base64data = reader.result;  
			var aux = base64data.split(',');
			this.props.socket.send('{"Operacion":"print", "Type":"'+label_type+'", "File": "'+aux[1]+'"}');
		}
	}

	onCancel(){
		this.props.history.push('/Shippings');
	}

	render(){
		const {t} = this.props;
		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					{t('sidebar.nav.reports.unit_send')}
					</h5>
				</div>
				<div className="form-group" style={{paddingLeft:"0.5em"}}>
					

					<div className="form-group col-xs-12">
						<div className="col-xs-12 col-sm-2">
							<img src={this.props.logo_1} style={{width:"50%"}} id="logo" alt="IMEDMEX"/>
						</div>
						<div className="col-xs-12 col-sm-8" style={{textAlign:"center"}}>
							<h3>
								<b>{session}</b>
							</h3>
							<h5><u>ENVÍO DE COMPONENTES SANGUÍNEOS</u></h5>
						</div>

						<div className="col-xs-12 col-sm-2" style={{paddingTop:"30px", textAlign:"right"}}>
							{this.state.report_date}
						</div>
						
					</div>
					<div className="col-xs-12">
						<div className="col-xs-12 col-sm-10">
							<div className="col-xs-12">
								<label>FOLIO No.</label>{' '+this.state.folio}
							</div>
							<div className="col-xs-12 form-group">
								{this.state.receptor_name}
							</div>
							<div className="col-xs-12" style={{paddingTop:"10px"}}>
								{'Presente, A solicitud de usted, enviamos los siguientes componentes sanguíneos:'}
							</div>
						</div>
						<div className="col-xs-12 col-sm-2" style={{border:"1px solid rgb(224, 219, 219)", fontSize:"10px"}}>
							<p style={{margin:"0"}}>CONSERVACIÓN</p>
							<p style={{margin:"0"}}>PFC: -18° C y -30° C</p>
							<p style={{margin:"0"}}>CE: +2° C y +10° C</p>
							<p style={{margin:"0"}}>PQH: +22° C y +24° C</p>

						</div>
					</div>
						
					<div className="col-xs-12 form-group">
						<div className="table-responsive">
							<table id="table-to-xls" className="table table-hover" ref={el => this.el = el}>
							</table>
						</div>
					</div>
					<div className="col-xs-12" style={{fontSize:"14px", textAlign:"right"}}>
						{this.state.components_count.map((c, i)=>{
							return <div key={i}><label >{c.component+': '}</label>{' '+c.count}</div>
						})}
					</div>
					<div className="col-xs-12 form-group" style={{fontSize:"14px", textAlign:"right"}}>
						<label>Total de unidades enviadas :</label>{' '+this.state.listado.length}
					</div>
					{this.state.observations !== "" ?
						<div className="col-xs-12 form-group" style={{fontSize:"16px"}}>
							<span>Observaciones: </span>
							<label>{this.state.observations}</label>
						</div>
					:null}
					{/*<div className="col-xs-12 form-group" style={{fontSize:"16px"}}>
						<span>Serología infecciosa Negativa a: <label style={{background:"#dcdee2"}}>Sifilis, HIV Ag/Ab,HBsAgQ2, HCV-3, Chagas Eli, Brucella</label>
						</span>
					</div>*/}
					<div className="col-xs-12" style={{textAlign:'center'}}>
			        	<div>
			        		<RaisedButton className="action-btn" label={t('content.generics.buttons.print')} primary={true} onClick={(e)=>this.onPrint(e)}  style={{margin:12}}/>
			        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} style={{margin:12}} onClick={this.onCancel}/>
			        	</div>
			        </div>
				</div>
				<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
			</div>
		)
	}
}
export default translate('translations')(ReportSend);